<template>
  <div class="row text-nowrap m-2 m-sm-4 font-italic">
    <div class="col flex-grow-1 flex-sm-grow-0 site-title-div">
      <div class="may24th-campaign width-fix mb-2">
        <img src="../../assets/img/aplus-may24.svg" alt="АдминПлюс" class="img-fluid">
      </div>
    </div>

    <div class="col flex-grow-1 flex-sm-grow-0 align-self-end text-right text-sm-left">
      <div class="may24th-campaign">
        <h2><strong>А</strong>з</h2>
        <h2><strong>Б</strong>уки</h2>
        <h2><strong>В</strong>еди</h2>
        <h2><strong>Г</strong>лаголи</h2>
        <h2><strong>Д</strong>обро</h2>
        <h2><strong>Е</strong>сть</h2>
        <h2><strong>Ж</strong>ичье</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "may24th-main-component"
}
</script>

<style scoped>

</style>
